import { useMemo } from 'react'
import { useSignedInUsersWeekStartsOn } from './useSignedInUsersWeekStartsOn'
import { useUser } from './useUsers'
import { useWeekDates } from './useWeekDates'
import { WeekScope } from 'providers/WeekScopeProvider'

/**
 * Establishes a week scope for the time logger, which renders one specific
 * user's dated week and so must follow that user's start day rather than the
 * start day of whoever is signed in. Falls back to the signed-in user's while
 * the viewed user is still in flight.
 */
export const useViewedUsersWeekScope = (userId: number) => {
  const signedInUsersWeekStartsOn = useSignedInUsersWeekStartsOn()
  const weekStartsOn =
    useUser(userId).data?.weekStartsOn ?? signedInUsersWeekStartsOn
  const { end, range, start } = useWeekDates({ weekStartsOn })

  const scope: WeekScope = useMemo(
    () => ({ end, range, start, weekStartsOn }),
    [end, range, start, weekStartsOn],
  )

  return { ...scope, scope }
}
